module.exports = "<p>\r\n  test works!\r\n</p>\r\n"